var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg3PointsGuest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "f0c57f52-a9b7-4ef4-9095-414951bc42ba",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "vbl") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "b7e1e1da-ea88-4b04-b865-683bc6a06600",
    cx: 62,
    cy: 56.44,
    r: 4.59
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b7e1e1da-ea88-4b04-b865-683bc6a06600",
    cx: 62,
    cy: 77.44,
    r: 4.59
  }), /*#__PURE__*/React.createElement("path", {
    className: "b7e1e1da-ea88-4b04-b865-683bc6a06600",
    d: "M98.38,24.28H29.63a13.51,13.51,0,0,0-13.5,13.5V96.53A13.51,13.51,0,0,0,29.63,110H98.38a13.52,13.52,0,0,0,13.5-13.5V37.78A13.51,13.51,0,0,0,98.38,24.28Zm10.5,72.25A10.51,10.51,0,0,1,98.38,107H29.63a10.51,10.51,0,0,1-10.5-10.5V68.65h8.5V79.5a11.75,11.75,0,0,0,23.5,0V68.65H88.44v0h.15a8.63,8.63,0,0,1,6.27,2.52c1.69,1.78,2.5,4.43,2.34,7.65-.26,5-4,8.84-8.76,8.84a8.77,8.77,0,0,1-8.76-8.76h-3A11.78,11.78,0,0,0,88.44,90.67c6.36,0,11.41-5,11.75-11.68.21-4.07-.88-7.48-3.16-9.88-.15-.16-.32-.3-.49-.46h12.34ZM48.13,68.65V79.5a8.75,8.75,0,1,1-17.5,0V68.65Zm-17.5-3V53a8.75,8.75,0,1,1,17.5,0V65.65Zm78.25,0H96.34c.15-.13.3-.26.44-.4,2.45-2.57,3.63-6.33,3.41-10.86-.33-7.14-5.39-12.51-11.75-12.51S76.68,47.52,76.68,54.46h3c0-5.29,3.93-9.58,8.76-9.58s8.5,4.15,8.76,9.65c.17,3.69-.72,6.68-2.6,8.65a8.29,8.29,0,0,1-5.86,2.47H51.13V53a11.75,11.75,0,1,0-23.5,0V65.65h-8.5V37.78a10.51,10.51,0,0,1,10.5-10.5H98.38a10.51,10.51,0,0,1,10.5,10.5Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3PointsGuest);
export default __webpack_public_path__ + "static/media/3-points-guest.d15b15c8c0fa9f83d9c391c700c7fa2c.svg";
export { ForwardRef as ReactComponent };